module.exports = __webpack_public_path__ + "media/images/undraw/matching/web_search-1707ca4b905742695a0d9266a27c430f.png";